  <form class="authForm">
    <h3 class="authForm__title">Вход</h3>
    {{{login}}}
    {{{password}}}
    {{{submitBtn}}}
    {{{signInBtn}}}
  </form>
